class BackedShippingProtection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    
    this.toggle = this.querySelector("input[data-toggle-shipping-protection]");
    this.backedProtectionPrice = this.querySelector("[data-backed-protection-price]");

    const backedInCartRemoved = JSON.parse( sessionStorage.getItem("backedInCartRemoved") );
    this.toggle.checked = !backedInCartRemoved;

    this._boundHandleToggle = this.handleToggle.bind(this);
    this.toggle.addEventListener("change", this._boundHandleToggle);
    
    // listen for event cart-updated and run updateComponent when that happens
    this._boundHandleCartUpdate = this.handleCartUpdate.bind(this);
    window.addEventListener("cart-updated", this._boundHandleCartUpdate);
    this._boundHandleAddToCart = this.handleAddToCart.bind(this);
    window.addEventListener("add-to-cart", this._boundHandleAddToCart);
    
    this.initComponent();

  }

  disconnectedCallback() {
    this.toggle.removeEventListener("change", this._boundHandleToggle);
    window.removeEventListener("cart-updated", this._boundHandleCartUpdate);
    window.removeEventListener("add-to-cart", this._boundHandleAddToCart);
  }

  async initComponent() {
    await this.updateComponent();
    await this.handleToggle();
  }

  async updateComponent() {
    try {
      
      
      const response = await fetch(window.Shopify.routes.root + "?sections=shipping-protection-section-rendering-api");
      const data = await response.json();

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = data["shipping-protection-section-rendering-api"];

      const newDataset = tempDiv.querySelector('backed-shipping-protection-helper').dataset;
      
      this.dataset.productId = newDataset.productId;
      this.dataset.variantId = newDataset.variantId;
      this.dataset.backedInCart = newDataset.backedInCart;
      this.dataset.cartAmount = newDataset.cartAmount;
      this.dataset.cartCount = Number( newDataset.cartCount );
      this.backedProtectionPrice.innerHTML = newDataset.backedProtectionPrice;
    } catch (error) {
      console.error("Error fetching collection data:", error);
    }
  }

  async handleCartUpdate(event) {
    const updatedProductId = event?.detail?.updatedProduct?.dataset?.productId || null;
    if (updatedProductId == this.dataset.productId || updatedProductId == null) return;
    await this.updateComponent();
    await this.handleToggle();
  }

  async handleAddToCart(event) {
    const isBackedProduct = event?.target?.dataset?.id == this.dataset.productId || false;
    if (isBackedProduct) return;
    await this.updateComponent();
    await this.handleToggle();
  }

  async handleToggle() {
    sessionStorage.setItem("backedInCartRemoved",!this.toggle.checked);

    if( Number( this.dataset.cartCount ) > 1 && this.toggle.checked && this.dataset.backedInCart && this.dataset.backedInCart === this.dataset.variantId ) return
    
    this.classList.add('processing');
    document.getElementById('CheckOut').setAttribute('disabled', 'disabled');

    // Remove existing backed protection
    if( 
      this.dataset.backedInCart && !this.toggle.checked ||
      this.dataset.backedInCart && Number( this.dataset.cartCount ) === 1 ||
      this.dataset.backedInCart && this.dataset.backedInCart !== this.dataset.variantId 
    ) {
      const updates = {};
      updates[this.dataset.backedInCart] = 0;
      try {
        const removeRequest = await fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify({ updates }),
        });
        if(removeRequest.ok) {
          const removeResult = await removeRequest.json(); 
          this.dataset.cartCount = removeResult.item_count
        } 
      } catch (error) {
        console.error("Error removing shipping protection:", error);
      }
    }


    // Add backed protection if checked & different from the current cart
    if (
      Number( this.dataset.cartCount ) > 0 && 
      this.toggle.checked && 
      this.dataset.variantId && 
      this.dataset.backedInCart !== this.dataset.variantId
    ) {
      try {
        let items = [{'id': this.dataset.variantId,'quantity': 1}];
        const addRequest = await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({ items }),
          })
      } catch (error) {
        console.error("Error adding shipping protection:", error);
      }
    }

    this.classList.remove('processing');
    document.getElementById('CheckOut').removeAttribute('disabled');
    
    await this.updateComponent();
    await this.updateCartUI();
  }

  async updateCartUI() {
    fetch(window.Shopify.routes.root + "?section_id=helper-cart")
      .then(response => response.text())
      .then(text => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
        const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
        const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

        const cartItems = document.getElementById('AjaxCartForm');
        cartItems.innerHTML = cartFormInnerHTML;
        cartItems.ajaxifyCartItems();

        document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
          elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
        });
        document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
          elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
        });

        document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
        const stickyFreeShippingBar = document.getElementById('StickyFreeShippingBar');
        if ( stickyFreeShippingBar ) stickyFreeShippingBar
          .querySelector('.mm-sticky-cart-price-container')
          .innerHTML = sectionInnerHTML.querySelector('#AjaxCartSubtotal .cart__total').innerHTML;
      })
      .catch(e => {
        console.log(e);
      });
    }

    // Helper function for updating cart UI
    ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', themedebounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

}
if (!customElements.get("backed-shipping-protection")) {
  customElements.define("backed-shipping-protection", BackedShippingProtection);
}
